export const ANALYTICS_EVENT_NAMES = {
    IMPRESSION: {
        CART: "impression-gifting-cart",
        GIFTBAG_HALFCARD: "impression-bag-selection-halfcard",
        GIFTBAG_PRIMARY_BUTTON: "impression-bag-selection-primary-button",
        GIFTBAG_SECONDARY_BUTTON: "impression-bag-selection-secondary-button",
        ITEM: "impression-gifting-cart-item",
    },
    CLICK: {
        GIFTBAG_CROSS_CTA: "click-bag-selection-cross-cta",
        GIFTBAG_PRIMARY_BUTTON: "click-bag-selection-primary-button",
        GIFTBAG_SECONDARY_BUTTON: "click-bag-selection-secondary-button",
        QUANTITY_INC: "click-gifting-cart-quantity-increase",
        QUANTITY_DEC: "click-gifting-cart-quantity-decrease",
        ADD_TO_CART: "click-gifting-cart-add-to-cart",
        REMOVE_FROM_CART: "click-gifting-cart-remove-from-cart",
    },
};
